define('app',['require','exports','module','lodash','jquery','lpg','backbone','i18n','router','services/auth/info','common/models/appstate','env','common/views/download_leads_popup','common/collections/globals','modules/includes_editor/index','ThemesHelper'],function (require, exports, module) {
  'use strict';

  var _ = require('lodash'),
    $ = require('jquery'),
    common = require('lpg'),
    Backbone = require('backbone'),
    i18n = require('i18n'),
    Router = require('router'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo(),
    AppState = require('common/models/appstate'),
    config = require('env'),
    DownloadLeadsPopup = require('common/views/download_leads_popup'),
    GlobalCollection = require('common/collections/globals'),
    IncludeContentService = require('modules/includes_editor/index');

  var app = module.exports;

  app.root = '/';

  app.defaultLang = 'es';

  app.initTheme = function () {
    var ThemesHelper = require('ThemesHelper');
    ThemesHelper.setConfig(config);
    ThemesHelper.initUserTheme();
  };

  app.i18nInit = function (callback, lang) {
    var initOptions = {
      resGetPath:
        '/app/locales/__lng__/__ns__.json' +
        (window.MD_TAG !== undefined ? '?' + window.MD_TAG : ''),
      fallbackLng: app.defaultLang,
      detectLngQS: 'lang',
      cookieName: 'md_i18next',
      cookieDomain: config.i18nCookieDomain,
      cookieExpirationTime: 100000,
      useDataAttrOptions: true,
      ns: {
        namespaces: ['translation'],
        defaultNs: 'translation',
      },
      debug: false,
    };
    if (lang) {
      initOptions.lang = lang;
    }

    i18n.init(initOptions, function (t) {
      if (callback) {
        callback();
      }
    });
  };

  app.i18n = function (el) {
    var $el = $(el);
    if ($el.i18n) {
      $el.i18n();
    } else {
      app.i18nInit(function () {
        $el.i18n();
      });
    }
  };

  app.setCompanyInfo = _.bind(AppState.initCompanyInfo, AppState);

  app.showGlobalsEditor = function (e) {
    var globals = new GlobalCollection(null, {
      companyId: authInfo.getCompanyId(),
    });

    IncludeContentService.editGlobals(globals, function () {
      globals.save();
    });

    globals.fetch({
      error: function (collection, resp) {
        if (resp.status === 404) {
          collection.saveMethod = 'create';
        }
      },
    });
  };

  app.checkActionsOnQueryParams = function () {
    var urlParams = new URLSearchParams(window.location.search);
    return app.processQueryParams(urlParams);
  };

  app.processQueryParams = function (urlParams) {
    var action = urlParams.get('action'),
      actionsAllowed = ['download_leads', 'edit_globals'];

    if (!action || !actionsAllowed.includes(action)) {
      return false;
    }

    if (action === 'download_leads') {
      DownloadLeadsPopup.show();
    } else if (action === 'edit_globals') {
      app.showGlobalsEditor();
    }
  };

  app.start = function () {
    app.initTheme();

    // Guard against leaving editor unsaved
    $(window).on('beforeunload', _.bind(AppState.onBeforeUnload, AppState));
    app.router = new Router();

    Backbone.history.start({
      pushState: true,
      root: app.root,
    });

    // Sidebar links behavior:
    $(document).on('click', '.md__sidebar__wrapper a[href]', function (evt) {
      if ($(evt.currentTarget).hasClass('upgrade__button')) {
        return true;
      }

      var hrefRaw = $(this).prop('href'),
        href = new URL(hrefRaw),
        root = location.protocol + '//' + location.host + app.root,
        targetRoot = href.origin + app.root;

      if (targetRoot === root) {
        // Pathname?  We're in the same domain, so we can just use the segment to navigate.
        if (href.pathname && href.pathname !== app.root) {
          // Forcing the item list to be selected in sidebar bypassing the router.
          var sidebarParentBlockItem = $(evt.currentTarget).closest('li');
          sidebarParentBlockItem.addClass('active').siblings().removeClass('active');

          Backbone.history.navigate(href.pathname, true);
          return;
        }

        // Query string?  Go to actions.
        if (href.search) {
          var urlParams = new URLSearchParams(href.search);
          app.processQueryParams(urlParams);
        }
      } else {
        // Different domain; we force the browser jump:
        window.location.replace(hrefRaw);
      }
    });

    // All navigation that is relative should be passed through the navigate
    // method, to be processed by the router. If the link has a `data-bypass`
    // attribute, bypass the delegation completely.
    $(document).on('click', '.main__section__wrapper a[href]:not([data-bypass])', function (evt) {
      // Get the absolute anchor href.
      var href = {
        prop: $(this).prop('href'),
        attr: $(this).attr('href'),
      };
      // Get the absolute root.
      var root = location.protocol + '//' + location.host + app.root;

      // Ensure the root is part of the anchor href, meaning it's relative.
      if (href.prop.slice(0, root.length) === root) {
        // Stop the default event to ensure the link will not cause a page
        // refresh.
        evt.preventDefault();

        // `Backbone.history.navigate` is sufficient for all Routers and will
        // trigger the correct events. The Router's internal `navigate` method
        // calls this anyways.  The fragment is sliced from the root.
        Backbone.history.navigate(href.attr, true);
      }
    });

    app.checkActionsOnQueryParams();
  };
});

